/**
 *service
 */
import taskmanAxios from '../helpers/axios'
/**
 * const
 */
import {
    API_MAKE_TASKS_ACTIVITIES_URL,
    API_MAKE_TASKS_ARCHIVE_URL,
    API_MAKE_TASKS_UNARCHIVE_URL,
    API_MAKE_TASKS_UPDATE_URL,
    API_MAKE_TASKS_INITIATE_COMPLETE_URL,
    API_TASKS_COMPLETE_CONFIRM_URL,
    API_TASKS_CREATE_URL, API_TASKS_LIST_URL, API_TASKS_REORDER_URL,
} from "../constants/api.constant";
import { normalizeTaskDate } from '../utils/formatDate'

function normalizeTaskPayload<T extends Record<string, any>>(task: T): T {
    if (!task || !Object.prototype.hasOwnProperty.call(task, 'due_date')) {
        return task
    }

    return { ...task, due_date: normalizeTaskDate(task.due_date) }
}

function normalizeTask<T extends Record<string, any>>(task: T, fallbackCreatedAt?: Date): T {
    if (!task) {
        return task
    }

    const createdAt = normalizeTaskDate(task.created_at, fallbackCreatedAt)

    const normalizedTask = normalizeTaskPayload(task)

    return createdAt
        ? { ...normalizedTask, created_at: createdAt }
        : normalizedTask
}

export default class TaskService {
    static async create(data: any){
        const createdAt = new Date()

        return await taskmanAxios.post(API_TASKS_CREATE_URL, normalizeTaskPayload(data))
            .then(response => normalizeTask(response.data, createdAt))
            .catch(e => Promise.reject(e));
    }

    static async list(){
        return await taskmanAxios.get(API_TASKS_LIST_URL)
            .then(response => {
                response.data.tasks.forEach( (task: any) => {
                    if(task.parent_id){
                        const parentTask = response.data.tasks.find(
                            (currentTask: any) => String(currentTask.id) === String(task.parent_id)
                        );

                        if(parentTask){
                            parentTask.relatedTasks = [...(parentTask.relatedTasks || []), task]
                        }
                    }
                })
                response.data.tasks = response.data.tasks
                    // .filter( (task: any) => !task.parent_id)
                    .map((task: any) => {
                        if(task.relatedTasks){
                            task.relatedTasks = [...task.relatedTasks, null]
                        }

                        return normalizeTask(task)
                    })

                return response.data
            })
            .catch(e => Promise.reject(e));
    }

    static async get(taskId: number | string){
        return await taskmanAxios.get(API_MAKE_TASKS_UPDATE_URL(taskId))
            .then(response => normalizeTask(response.data))
            .catch(e => Promise.reject(e));
    }

    static async initiateComplete(taskId: number | string){
        return await taskmanAxios.post(API_MAKE_TASKS_INITIATE_COMPLETE_URL(taskId), {
            "status": "complete"
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }
    static async completeConfirm(session_token: string){
        return await taskmanAxios.post(API_TASKS_COMPLETE_CONFIRM_URL, {
            "status": "approved",
            session_token
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async update(taskId: number, data: any){
        return await taskmanAxios.put(API_MAKE_TASKS_UPDATE_URL(taskId), normalizeTaskPayload(data))
            .then(response => normalizeTask(response.data))
            .catch(e => Promise.reject(e));
    }

    static async reorder(data: { project_id: number | string; status: string; task_ids: number[] }){
        return await taskmanAxios.patch(API_TASKS_REORDER_URL, data)
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async delete(taskId: number){
        return await taskmanAxios.delete(API_MAKE_TASKS_UPDATE_URL(taskId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async activities(taskId: number){
        return await taskmanAxios.get(API_MAKE_TASKS_ACTIVITIES_URL(taskId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async archive(taskId: number){
        return await taskmanAxios.post(API_MAKE_TASKS_ARCHIVE_URL(taskId), {})
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async unarchive(taskId: number){
        return await taskmanAxios.post(API_MAKE_TASKS_UNARCHIVE_URL(taskId), {})
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }
}
